import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'

const About = () => {
    useEffect(() =>{
        document.title = "About Earth VIII"
    },[])

    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>

<div  class="aboutfirstbox">
<div class="container">
<div class="row">
<div class="col-md-6">
<img className="img-fluid fordesktoponly" src="images/aboutusimg.png"/>

   

</div>

<div class="col-md-6">
<h3 className="aboutherotitle">A bit about Earth VII 
    </h3>
    <p style={{paddingTop:"20px"}} className="homesherosubtitle homesherosubtitlesmallerscreen fordesktoponly">
    Earth VII is managed by a team of experienced professionals and is a member of Rich-Oak Group 
    which gives her the advantage of an immense reserve of resources and experience, giving it the ability to effectively plan, 
    develop and manage smart and fully automated properties for individuals, private organizations, state and federal government
     establishments, while strategically positioning the company to consolidate its activities across Abuja, Nigeria.         </p>

    <p className="homesherosubtitle homesherosubtitlesmallerscreen  fordesktoponly">We are a key player in realizing Abuja’s vision of becoming a cosmopolitan city and as well as the Goldman Sachs report on future emerging economies that the country will be among the top 20 economies worldwide by the year 2021; creating a world class destination for living, business and tourism
         </p>
    
         <p className="homesherosubtitle formobileonly aboutsubtitle">
         Earth VII is managed by a team of experienced professionals and is a member of Rich-Oak Group which gives her the advantage of an immense reserve of resources and experience, giving it the ability to effectively plan, develop and manage smart and fully automated properties for individuals, private organizations, state and federal government establishments, while strategically positioning the company to consolidate its activities across Abuja, Nigeria. 
</p>
         <p className="homesherosubtitle formobileonly aboutsubtitle">We are a key player in realizing Abuja’s vision of becoming a cosmopolitan city and as well as the Goldman Sachs report on future emerging economies that the country will be among the top 20 economies worldwide by the year 2021; creating a world class destination for living, business and tourism
     
         </p>
         <img className="img-fluid formobileonly" src="images/aboutusimg.png"/>

    </div>

    </div>
    </div>
</div>




<div className='aboutsecondbox'>
    <div className='container'>
       <div class="row">
           <div class="col-md-12">


<div class="row">
    
<div class="col-md-3 col-6 apartmentsstepsbox">
<h3 className="apartmentsboxtitle apartmentsboxtitlesmallerscreen">Our Mission</h3>
 <p className="aboutsteps">
     Partnering with individuals to build luxurious homes that last, 
     that create beautiful stories and hold memories for generations</p>
</div>

<div class="col-md-3 col-6 apartmentsstepsbox">
<h3 className="apartmentsboxtitle apartmentsboxtitlesmallerscreen">Our Vision</h3>
<p className="aboutsteps">
To be Africa’s most reliable real estate partner 
     
     </p>
</div>


<div class="col-md-3 col-6 apartmentsstepsbox5">
<h3 className="apartmentsboxtitle apartmentsboxtitlesmallerscreen">Strategic Objectives</h3>
 <p className="aboutsteps">
 Our strategic focus is centered on building exceptional properties in some of Nigeria’s most desirable locations.
     </p>
     <br/>
     
</div>

<div class="col-md-3 col-6 apartmentsstepsbox5">
<h3 className="apartmentsboxtitle apartmentsboxtitlesmallerscreen">Our Core Values</h3>
<div class="row">
                    <div class="col-md-6">
                    <p className="aboutsteps"><img className="img-fluid" src="images/icons/check.png"/> Excellence</p>
                    <p className="aboutsteps"><img className="img-fluid" src="images/icons/check.png"/> Innovation</p>



                    </div>
                    <div class="col-md-6">
                    <p className="aboutsteps"><img className="img-fluid" src="images/icons/check.png"/> Versatility</p>
                    <p className="aboutsteps"><img className="img-fluid" src="images/icons/check.png"/> Integrity</p>


                    </div>
                </div>
</div>



</div>
 
           </div>


   
       </div>
        </div>
    </div>














{/* <br/>
<br/> */}

{/* <Testimonials/> */}


{/* <Faq/> */}

<div  className="formobileonly">
    <p style={{marginTop:"0px" }}></p>
    </div>
<Contact/>








    </div>






    <Footer/>
    </div>


    )
    
    
}


export {About as default}